module.exports = __webpack_public_path__ + "img/the-broken-kingdoms.a33e0837.png";